import { useClarificationRequestModel } from "entities/clarification-requests/model/useClarificationRequestModel"
import { clarificationRequestResourceTypeMap } from "entities/clarification-requests/types/ClarificationRequest"
import { useAggregatedFloorData } from "entities/floors/api/useAggregatedFloorData"
import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useFloorActionHandlers } from "features/floor-management/model/useFloorActionHandlers"

import { FloorModel } from "../types/FloorModel"

export interface UseFloorOptions {
  includePrice?: boolean
  isShared?: boolean
}

export function useFloor({
  floorID,
  projectID,
  options
}: {
  floorID: string
  projectID: string
  options?: UseFloorOptions
}): FloorModel {
  const data = useAggregatedFloorData({ floorID, projectID, options })
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useFloorActionHandlers({
    projectID,
    floorID,
    permissions: permissions ?? readonlyProjectPermissions
  })
  const clarificationRequest = useClarificationRequestModel({
    resourceType: clarificationRequestResourceTypeMap.Floor,
    id: floorID,
    projectID
  })

  const { onAssignAttachments, ...coreHandlers } = handlers

  return {
    core: {
      data: { floor: data.floor },
      handlers: coreHandlers
    },
    pricing: {
      data: { price: data.price }
    },
    clarificationRequest,
    attachments: {
      data: { attachments: null, linkedAttachments: null },
      handlers: { onAssignAttachments }
    }
  }
}
